import React from 'react';
import { Cross2Icon, FileTextIcon } from '@radix-ui/react-icons';

interface ModalHeaderProps {
  title?: string;
  onClose: () => void;
  disabled?: boolean;
}

export const ModalHeader: React.FC<ModalHeaderProps> = ({
  title = 'Task Details',
  onClose,
  disabled = false,
}) => (
  <header className="task-details-modal__header">
    <div className="task-details-modal__header-title">
      <FileTextIcon aria-hidden="true" />
      <h2 id="task-details-modal-title">{title}</h2>
    </div>
    <button
      type="button"
      className="task-details-modal__close"
      onClick={onClose}
      disabled={disabled}
      aria-label="Close"
    >
      <Cross2Icon />
    </button>
  </header>
);
